import React from "react";

function BitcoinWalletDevSer() {
  return (
    <>
      <div>
        <div className="container p-5">
          <div
            className="pricing-style-one-item-cos bg-dark text-light"
            style={{
              backgroundImage:
                "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
            }}
          >
            <div className="text-center">
              <h3>Bitcoin Wallet Development Service</h3>
              <div className="bottom">
                <div className="pricing">
                  <p>
                    At Xeer Technology, we offer comprehensive Bitcoin Wallet
                    Development Services to help individuals, startups, and
                    enterprises create secure and feature-rich Bitcoin wallets.
                    Our expertise lies in building custom wallets tailored to
                    meet your specific needs, whether you’re seeking a simple
                    storage solution or a complex, multi-functional wallet for
                    your business.
                  </p>
                </div>
                <a className="btn btn-style-one mt-30" href="#">
                  Get Started
                </a>
              </div>
            </div>
            {/* <div className="right-info"></div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default BitcoinWalletDevSer;
